import React from 'react';
import { twMerge } from 'tailwind-merge';
import ButtonComponent from './buttonComponent';
import { ReactComponent as Filter } from 'assets/icons/filter.svg';

interface IFilterButton {
  label?: string;
  handleFilterClick: () => void;
  count?: string | null;
  testID?: string;
  className?: string;
  isOpenFilter?: boolean;
}

const FilterButton: React.FC<IFilterButton> = ({
  label,
  handleFilterClick,
  count,
  isOpenFilter,
  className,
  testID = 'filter-icon',
}) => {
  return (
    <ButtonComponent
      Icon={Filter}
      iconPosition="left"
      iconWidth="w-[20px]"
      className={twMerge(
        'ml-auto group h-fit !text-sm desktop:!min-w-[110px] max-desktop:mb-auto max-desktop:w-[46px] !p-3 !border',
        className,
      )}
      onClick={handleFilterClick}
      testID={testID}
      containerClassName="!gap-0.5"
      type={isOpenFilter ? undefined : 'outlined-transparent'}
    >
      <span className="max-desktop:hidden">{label}</span>
      {count && (
        <span
          className={twMerge(
            'w-5 h-5 p-1 text-[13px] text-white rounded-full bg-clc-blue flex items-center justify-center group-hover:bg-white group-hover:text-clc-blue',
            isOpenFilter &&
              'bg-white text-med-gray-3 group-hover:bg-clc-blue group-hover:text-white',
          )}
        >
          {count}
        </span>
      )}
    </ButtonComponent>
  );
};

export default FilterButton;
